/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trial_EndsInputs */

const en_trial_ends = /** @type {(inputs: Trial_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial Ends`)
};

const fr_trial_ends = /** @type {(inputs: Trial_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin du procès`)
};

const de_trial_ends = /** @type {(inputs: Trial_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozess beendet`)
};

const it_trial_ends = /** @type {(inputs: Trial_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il processo termina`)
};

const ru_trial_ends = /** @type {(inputs: Trial_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Судебное разбирательство завершилось.`)
};

const es_trial_ends = /** @type {(inputs: Trial_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El juicio termina`)
};

const zh_cn2_trial_ends = /** @type {(inputs: Trial_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审判结束`)
};

const ja_trial_ends = /** @type {(inputs: Trial_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`裁判終了`)
};

const hi_trial_ends = /** @type {(inputs: Trial_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुकदमा समाप्त`)
};

const pt_pt2_trial_ends = /** @type {(inputs: Trial_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O julgamento termina`)
};

/**
* | output |
* | --- |
* | "Trial Ends" |
*
* @param {Trial_EndsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const trial_ends = /** @type {((inputs?: Trial_EndsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trial_EndsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_trial_ends(inputs)
	if (locale === "de") return de_trial_ends(inputs)
	if (locale === "it") return it_trial_ends(inputs)
	if (locale === "ru") return ru_trial_ends(inputs)
	if (locale === "es") return es_trial_ends(inputs)
	if (locale === "zh-CN") return zh_cn2_trial_ends(inputs)
	if (locale === "ja") return ja_trial_ends(inputs)
	if (locale === "hi") return hi_trial_ends(inputs)
	if (locale === "pt-PT") return pt_pt2_trial_ends(inputs)
	return en_trial_ends(inputs)
});